// src/components/ServicesSection.jsx
import React from "react";
import { useState } from "react";
import servicesData from "../../assets/servicesData";
import { useNavigate } from "react-router-dom";

// Reusable Card Component with 3D Flip
const ServiceCard = ({ icon, title, description, imageSrc, backContent }) => {
  const navigate = useNavigate();
  const [flipped, setFlipped] = useState(false);

  const handleNavigateToService = (e) => {
    e.stopPropagation();
    navigate(`/services`);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleFlip = () => {
    setFlipped((prev) => !prev);
  };

  return (
    <div
      className="perspective cursor-pointer"
      style={{ minHeight: "480px" }}
      onClick={handleFlip}
    >
      <div
        className="relative w-full h-full transition-transform duration-700"
        style={{
          transformStyle: "preserve-3d",
          transform: flipped ? "rotateY(180deg)" : "rotateY(0deg)",
          minHeight: "480px",
        }}
      >
        {/* ===== FRONT SIDE ===== */}
        <div
          className="backface-hidden absolute inset-0 group p-8 rounded-xl flex flex-col justify-between shadow-md border hover:border-t-4 hover:border-gray-900 hover:bg-gray-900/80 hover:text-white transition-colors duration-300 bg-white"
        >
          <div>
            <div className="w-12 h-12 flex items-center justify-center bg-gray-100 text-gray-900 rounded-full mb-6 group-hover:bg-white group-hover:text-gray-900 transition duration-300">
              {icon}
            </div>

            <h3 className="text-xl font-semibold mb-2 text-gray-900 group-hover:text-white">
              {title}
            </h3>
            <p className="text-gray-600 group-hover:text-gray-300 mb-6 text-base">
              {description}
            </p>

            <div className="mb-6 h-48 overflow-hidden rounded-lg">
              <img
                src={imageSrc}
                alt={title}
                className="w-full h-full object-cover transition duration-300 group-hover:scale-105"
              />
            </div>
          </div>

        </div>

        {/* ===== BACK SIDE ===== */}
        <div
          className="backface-hidden rotate-y-180 absolute inset-0 p-6 rounded-xl flex flex-col overflow-hidden shadow-md border bg-gray-900 text-white"
        >
          {/* Scrollable content area */}
          <div className="flex-1 min-h-0 overflow-y-auto mb-4">
            <div className="w-10 h-10 flex items-center justify-center bg-white text-gray-900 rounded-full mb-4">
              {icon}
            </div>

            <h3 className="text-lg font-semibold mb-3">{title}</h3>

            <ul className="space-y-3">
              {backContent &&
                backContent.map((item, i) => (
                  <li key={i} className="flex items-start gap-2.5 text-gray-200">
                    <svg
                      className="w-4 h-4 text-emerald-400 mt-0.5 flex-shrink-0"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2.5"
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                    <span className="text-sm leading-relaxed">{item}</span>
                  </li>
                ))}
            </ul>
          </div>

          {/* Button pinned at bottom */}
          <div className="flex-shrink-0">
            <button
              onClick={handleNavigateToService}
              className="w-full flex items-center justify-between px-4 py-3 bg-white text-gray-900 text-sm font-medium rounded-lg hover:bg-gray-100 transition duration-300"
            >
              <span>Learn more</span>
              <svg
                className="w-4 h-4 transform hover:translate-x-1 transition duration-200"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const ServicesSection = () => {
  return (
    <section className="pt-24 pb-4 bg-gray-50 font-sans">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Header */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 mb-16">
          <div>
            <span className="text-sm font-medium text-gray-700 bg-gray-100 border border-gray-300 px-3 py-1 rounded-full mb-4 inline-block">
              Our Expertise
            </span>
            <h2 className="text-5xl font-light leading-snug text-gray-900">
              Empowering Industries <br /> through Next-Gen Technology
            </h2>
          </div>
          <div className="flex items-start items-center">
            <p className="text-lg text-gray-700 max-w-lg">
              At Crack Developers, we bridge the gap between complex problems and elegant digital solutions. While we serve a diverse range of industries, we take immense pride in our specialized focus on the Education Sector, helping institutions transition into the future of learning.
            </p>
          </div>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {servicesData.map((service, index) => (
            <ServiceCard
              key={index}
              icon={service.icon}
              title={service.title}
              description={service.description}
              imageSrc={service.imageSrc}
              backContent={service.backContent}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
